/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { resBreak } from '@/utils/resBreak';
import { SxProps, Theme } from '@mui/material';

export const footerContainerSX = (csrSession: boolean, checkoutFlow? : boolean) : SxProps<Theme> => ({
	borderRadius: '0',
	fontSize:globalBreak({mobile:14, desktop:16}),
	alignSelf: 'stretch',
	justifySelf: 'flex-end',
	backgroundColor: 'background.paper',
	color: 'background.disabled',
	img: {
		height: (theme) => theme.spacing(3),
	},
	position:'relative',
	marginTop: (theme) => theme.dimensions.contentSpacing,
	...(!csrSession && { mt: 'auto' }),
	'& .arc-wrapper': {
		width: '100%',
		height: globalBreak({mobile:100,desktop:150}),
		overflow: 'hidden',
		borderTop:'none',
		mb:checkoutFlow?0:'-2em',
		mt:checkoutFlow?globalBreak({mobile:6,desktop:6}):0,
	},
	'& .arc-wrapper svg': {
		width: '100%',
		height: '100%',
		display: 'block',
		transform: resBreak<'transform'>({mobile:'rotateY(180deg)', desktop:'rotateY(0)', tablet:'rotateY(180deg)'})
	},
	'& .footer-news-letter-and-social':{
		display:'flex',
		flexDirection:'column',
		rowGap:2
	},
});





